// src/components/SEO.js
// Gestisce i tag <link rel="alternate" hreflang="..."> nel <head>,
// aggiornandoli ad ogni cambio di pagina. Niente librerie esterne:
// il progetto non usa react-helmet, quindi manipoliamo il DOM a mano
// con un semplice useEffect (compatibile con CRA).
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SUPPORTED_LANGS, DEFAULT_LANG, isSupportedLang } from "../constants/languages";

const SITE_URL = "https://www.evatazzari.com";

// Ricostruisce lo stesso percorso ma con l'altro prefisso lingua
function buildAltPath(pathname, targetLang) {
  const segments = pathname.split("/");
  if (isSupportedLang(segments[1])) {
    segments[1] = targetLang;
  } else {
    segments.splice(1, 0, targetLang);
  }
  return segments.join("/") || `/${targetLang}`;
}

export default function SEO() {
  const location = useLocation();

  useEffect(() => {
    const pathname = location.pathname;
    const currentSegment = pathname.split("/")[1];
    document.documentElement.lang = isSupportedLang(currentSegment)
      ? currentSegment
      : DEFAULT_LANG;

    const itHref = `${SITE_URL}${buildAltPath(pathname, "it")}`;
    const enHref = `${SITE_URL}${buildAltPath(pathname, "en")}`;
    const defaultHref = `${SITE_URL}${buildAltPath(pathname, DEFAULT_LANG)}`;

    const entries = [
      ...SUPPORTED_LANGS.map((lang) => ({
        hrefLang: lang,
        href: lang === "it" ? itHref : enHref,
      })),
      { hrefLang: "x-default", href: defaultHref },
    ];

    const createdElements = entries.map(({ hrefLang, href }) => {
      const el = document.createElement("link");
      el.setAttribute("rel", "alternate");
      el.setAttribute("hreflang", hrefLang);
      el.setAttribute("href", href);
      document.head.appendChild(el);
      return el;
    });

    return () => {
      createdElements.forEach((el) => {
        if (el.parentNode) el.parentNode.removeChild(el);
      });
    };
  }, [location.pathname]);

  return null;
}
